import {
  actionHideMeasurements,
  actionSetSceneRect,
  actionSetWallResizerActive,
  actionSetWallResizerInactive,
  actionShowMeasurements,
} from './sceneActions';
import {
  selectIsMeasurementsActive,
  selectIsWallResizerActive,
} from './sceneSelectors';
import {
  selectIsKiosk,
  selectIsMobile,
  selectIsPortrait,
  selectUserAgent,
} from '../userAgent/userAgentSelectors';

import constants from '../../settings/constants';
import { selectCurrentView } from '../navigation/navigationSelectors';
import { isFixedRoom } from '../../util/room';
import { selectWallPoints, selectWallSize } from '../tac/tacSelectors';
import { actionSetMargins, actionSetRoom } from './sceneActions';
import { selectSceneRect } from './sceneSelectors';
import _ from 'lodash';

export const thunkToggleMeasurements = meta => (dispatch, getState) => {
  selectIsMeasurementsActive(getState())
    ? dispatch(actionHideMeasurements(meta))
    : dispatch(actionShowMeasurements(meta));
};

export const thunkSetWallResizerActive = meta => (dispatch, getState) => {
  selectIsMeasurementsActive(getState()) &&
    dispatch(actionHideMeasurements({ nonInteraction: true }));
  dispatch(actionSetWallResizerActive(meta));
};

export const thunkToggleWallResizer = meta => (dispatch, getState) => {
  const wallResizerActive = selectIsWallResizerActive(getState());
  const measurementsActive = selectIsMeasurementsActive(getState());
  if (wallResizerActive) {
    return dispatch(actionSetWallResizerInactive(meta));
  }
  measurementsActive && dispatch(actionHideMeasurements(meta));
  return dispatch(actionSetWallResizerActive(meta));
};

export const thunkSetMargins = () => (dispatch, getState) => {
  const getMobilePortraitPercentual = () => {
    return constants.CANVAS_MARGINS_PORTRAIT_PERCENTUAL['mobile'];
  };
  const getTabletPortraitPercentual = () => {
    return constants.CANVAS_MARGINS_PORTRAIT_PERCENTUAL['tablet'];
  };
  const getPortraitPercentual = () => {
    return selectIsMobile(getState())
      ? getMobilePortraitPercentual()
      : getTabletPortraitPercentual();
  };
  const getWallHeight = () => {
    return selectIsWallResizerActive(getState())
      ? constants.WALL.height.max
      : selectWallSize(getState()).height;
  };
  const getWallWidth = () => {
    return selectIsWallResizerActive(getState())
      ? constants.WALL.width.max
      : selectWallSize(getState()).width;
  };

  const wallPointsExist = () => {
    return selectWallPoints(getState()) && selectWallPoints(getState()).length;
  };

  const getMargins = () => {
    if (selectCurrentView(getState()) === constants.VIEW_NAMES.SUMMARY) {
      return {
        top: selectSceneRect(getState()).height * 0.2,
        right: 0,
      };
    }
    if (selectIsPortrait(getState()) && isFixedRoom() && wallPointsExist()) {
      return {
        top: getPortraitPercentual() * getWallHeight(),
        right: getPortraitPercentual() * getWallWidth(),
      };
    } else {
      return selectIsKiosk(getState())
        ? constants.CANVAS_MARGINS_KIOSK
        : selectIsMobile(getState())
        ? constants.CANVAS_MARGINS_MOBILE
        : constants.CANVAS_MARGINS;
    }
  };
  dispatch(actionSetMargins(getMargins()));
};

export const thunkSetMinRoom = () => (dispatch, getState) => {
  const getMinRoom = () => {
    const currentView = selectCurrentView(getState());
    const isMobile = selectUserAgent(getState()).isMobile;
    if (currentView === constants.VIEW_NAMES.SUMMARY)
      return constants.ROOM_MIN_SUMMARY;
    return isMobile ? constants.ROOM_MIN_MOBILE : constants.ROOM_MIN_DESKTOP;
  };
  dispatch(actionSetRoom({ minRoom: getMinRoom() }));
};

export const thunkSetSceneRect = sceneRect => (dispatch, getState) => {
  const currentSceneRect = selectSceneRect(getState());
  if (!_.isEqual(currentSceneRect, sceneRect)) {
    dispatch(actionSetSceneRect(sceneRect));
  }
};
